import React from 'react';
import './login-background.scss';
import PasoAPaso from '../../../../images/paso_a_paso.png';

export default () => {
    return (
        <div className='login-background'>
            <div className='login-background-content'>
                <h1 className='title'>Ahora tus capacitaciones están en ACHS Virtual</h1>
                <img alt='instructions' src={PasoAPaso}></img>
            </div>
        </div>
    )
}
